import { CSSProperties, useContext } from "react";
import UpgradeToProLabel from "./UpgradeToProLabel";
import { UpgradeModalContext } from "Hooks/UpgradeModalContext";
import { PlanType } from "modules/Const";
import ButtonSymphony from "../../elements/ButtonSymphony";
import { clsx, styx } from "modules/Utils";
import Icon from "elements/Icon";

interface UnlockDataBannerProps {
    className?: string;
    style?: CSSProperties;
    title?: string;
    image?: string;
    hideImage?: boolean;
    description?: string;
    secondDescription?: string;
    imageMaxWidth?: string;
    source?: string;
    unlockedWithLite?: boolean;
}

const UnlockDataBanner = ({
    className,
    style,
    title,
    description,
    secondDescription,
    image,
    hideImage,
    imageMaxWidth,
    source,
    unlockedWithLite,
}: UnlockDataBannerProps) => {
    const { handleOpenModal } = useContext(UpgradeModalContext);

    const starsIcon = <Icon className="unlockDataBannerButtonIconLeft" icon="stars" color="white" size={20} />

    return (
        <div
            className={clsx('unlockDataBannerComponent', className)}
            style={styx(
                {
                    justifyContent: "center",
                    borderRadius: 12,
                    display: "flex",
                    padding: 20,
                    gap: 40,
                    alignItems: "center",
                    backgroundColor: "rgba(136, 0, 255, 0.08)",
                },
                style
            )}
        >
            {image && !hideImage &&
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "25%",
                        maxWidth: imageMaxWidth,
                        padding: "0px 0px 0px 32px",
                    }}
                >
                    <img
                        className="unlockDataBannerImage"
                        style={styx(
                            sty.imageUnlockDataBanner,
                            {
                                maxWidth: imageMaxWidth,
                                maxHeight: imageMaxWidth,
                            }
                        )}
                        alt="unlock-data-chart.svg"
                        src={image}
                    />
                </div>
            }
            <div
                className="unlockDataBannerContent"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "75%",
                }}
            >
                <UpgradeToProLabel
                    className="unlockDataBannerUpgradeToProLabel"
                    color="YELLOW"
                    label={unlockedWithLite ? 'Symphony Lite' : 'Symphony Pro'}
                />
                {title &&
                    <span
                        className="unlockDataBannerTitle"
                        style={styx(sty.labelUnlock, { fontSize: 20, fontWeight: 500, marginTop: 12 })}
                    >
                        {title}
                    </span>
                }
                {description &&
                    <span
                        className="unlockDataBannerDescription"
                        style={styx(sty.labelUnlock, { color: "#707070", marginTop: "2px" })}
                    >
                        {description}
                    </span>
                }
                {secondDescription &&
                    <span
                        className="unlockDataBannerDescription"
                        style={styx(sty.labelUnlock, { color: "#707070" })}
                    >
                        {secondDescription}
                    </span>
                }
                <ButtonSymphony
                    className="unlockDataBannerButton"
                    style={{ marginTop: 12 }}
                    onClick={() => handleOpenModal({
                        source: source ? source : "Unlock Data Banner in Campaign Details",
                        highlightedPlan: unlockedWithLite ? PlanType.LITE : PlanType.PRO,
                    })}
                    iconLeft={starsIcon}
                    iconRight={
                        <div style={{ transform: "scaleX(-1)" }}>
                            {starsIcon}
                        </div>
                    }
                >
                    {unlockedWithLite ? 'Upgrade to Lite' : 'Upgrade to Pro'}
                </ButtonSymphony>
            </div>
        </div>
    );
};

const sty: Record<string, CSSProperties> = {
    imageUnlockDataBanner: {
        width: "80%",
        height: "80%",
    },
    labelUnlock: {
        fontSize: 16,
        fontWeight: 400,
        color: "black",
    },
}

export default UnlockDataBanner;
